import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  BrandLogoUploadRequestSchema,
  BrandPaletteSchema,
  BrandSchema,
  BrandUpdateRequestSchema,
} from '../shared/schemas/BrandSchema.js';

export type BrandType = z.infer<typeof BrandSchema>;
export type BrandPaletteType = z.infer<typeof BrandPaletteSchema>;
export type BrandUpdateRequestType = z.infer<typeof BrandUpdateRequestSchema>;

export const getBrand = defaultClient.query({
  url: 'ai-assistant/brand' as const,
  method: 'GET',
  responseSchema: BrandSchema,
});

export const getBrandLogo = defaultApi.declareStream({
  url: 'ai-assistant/brand/logo' as const,
  method: 'GET',
});

export const updateBrand = defaultClient.mutation({
  url: 'ai-assistant/brand/$clientId' as const,
  method: 'PUT',
  clientOptions: { request: { snakeCaseBody: false } },
  requestSchema: BrandUpdateRequestSchema,
  responseSchema: z.unknown(),
  processResponse(data) {
    return data;
  },
});

export const uploadBrandLogo = defaultClient.mutation({
  url: 'ai-assistant/brand/$clientId/logo' as const,
  method: 'POST',
  clientOptions: { headers: { 'Content-Type': 'multipart/form-data' } },
  requestSchema: BrandLogoUploadRequestSchema,
  responseSchema: z.unknown(),
  processResponse(data) {
    return data;
  },
});
